import { MapTo } from '@adobe/aem-react-editable-components';
import PressKit, { PressKitEditConfig } from './PressKit';

export default MapTo('cob-corp-acquisition/components/creditonebank/press-kit')(PressKit, PressKitEditConfig);